import { FormSection } from '@@/form-components/FormSection';
import { SwitchField } from '@@/form-components/SwitchField';
import { TextTip } from '@@/Tip/TextTip';

export type KubernetesDeployerOptions = {
  Prune?: boolean;
  ForceApply?: boolean;
};

type KubernetesDeployerOptionsFormValues = {
  KubernetesPrune: boolean;
  KubernetesForceApply: boolean;
};

type Props = {
  values: KubernetesDeployerOptionsFormValues;
  onChange: (value: Partial<KubernetesDeployerOptionsFormValues>) => void;
};

export function KubernetesDeployerOptionsFieldset({ values, onChange }: Props) {
  return (
    <FormSection title="Deployment options">
      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.KubernetesPrune}
            data-cy="edge-stack-deployer-option-kubernetes-prune"
            name="deployerOptionsKubernetesPrune"
            label="Prune resources"
            tooltip="When this stack is updated, delete the resources it previously created that the manifest no longer declares. Turning this off leaves those resources running on the cluster with nothing in Portainer pointing at them."
            labelClass="col-sm-3 col-lg-2"
            onChange={(KubernetesPrune) => onChange({ KubernetesPrune })}
          />
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.KubernetesForceApply}
            data-cy="edge-stack-deployer-option-kubernetes-force-apply"
            name="deployerOptionsKubernetesForceApply"
            label="Force recreate"
            tooltip="Some fields cannot be changed after a resource is created. Turning this on lets Portainer delete and recreate such a resource instead of failing the deployment."
            labelClass="col-sm-3 col-lg-2"
            onChange={(KubernetesForceApply) =>
              onChange({ KubernetesForceApply })
            }
          />
        </div>
      </div>

      {values.KubernetesForceApply && (
        <div className="form-group">
          <div className="col-sm-12">
            <TextTip color="orange">
              Resources whose immutable fields changed will be deleted and
              recreated. Expect downtime, and data loss for resources that hold
              data.
            </TextTip>
          </div>
        </div>
      )}
    </FormSection>
  );
}
